<span class="modal-trigger">
	<v-dialog max-width="48em" v-model="isOpen">
		<template v-slot:activator="{ props }">
			<v-btn class="modal-trigger__button" :color="color" v-bind="props">{{ buttonText }}</v-btn>
		</template>
		<component :is="componentName" @close="handleClose" v-bind="bindableComponentProps"/>
	</v-dialog>
</span>
